module.exports = __webpack_public_path__ + "img/5f9085b92b55cff7dfbce5b933c3b608.png";